import * as yup from 'yup';

export const editBillingSchema = yup.object().shape({
  amount: yup.string().required('Este campo é obrigatório.'),
});
